import React, { useState } from "react";
import {
  AiOutlineCalendar,
  AiOutlineDownload,
  AiOutlineFileAdd,
} from "react-icons/ai";
import man from "../../../assests/userprofiledefaultpic.jpg";
import { useNavigate } from "react-router-dom";
import { set, toJS } from "mobx";
import PdfViewer from "../pdfViewer";
import { CiLocationOn } from "react-icons/ci";
import { GoFileDiff } from "react-icons/go";
import { HiOutlineMail } from "react-icons/hi";

const CircularProgress = ({ percentage }) => {
  const strokeWidth = 5;
  const size = 50;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="relative flex items-center justify-center">
      <svg width={size} height={size} className="transform -rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#22c55e"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className="absolute text-green-600 text-sm font-extrabold">
        {percentage}%
      </span>
    </div>
  );
};

const ScoreCircle = ({ score }) => {
  const circleRadius = 20;
  const circleCircumference = 2 * Math.PI * circleRadius;
  const strokeDashoffset =
    circleCircumference - (score / 100) * circleCircumference;

  // Determine the color based on the score
  const getColor = () => {
    if (score >= 75) return "text-green-500"; // Green for high scores
    if (score >= 50) return "text-yellow"; // Yellow for medium scores
    return "text-red-500"; // Red for low scores
  };

  const colorClass = getColor();

  const getTextColor = () => {
    if (score >= 75) return "#34D399"; // Green for high scores (Tailwind green-500)
    if (score >= 50) return "#FBBF24"; // Yellow for medium scores (Tailwind yellow-500)
    return "#F87171"; // Red for low scores (Tailwind red-500)
  };

  const textcolor = getTextColor();

  return (
    <div className="flex justify-center items-center -mr-4 md:mr-0 lg:mr-0 ">
      <svg className="lg:mr-0 md:mr-0 -mr-4" width="80" height="80">
        {/* Rotating group */}
        <g transform="rotate(-90 40 60)">
          <circle
            className="text-gray-200"
            cx="60"
            cy="60"
            r={circleRadius}
            fill="transparent"
            stroke="currentColor"
            strokeWidth="4"
          />
          <circle
            className={`${colorClass}`}
            cx="60"
            cy="60"
            r={circleRadius}
            fill="transparent"
            stroke="currentColor"
            strokeWidth="4"
            strokeDasharray={circleCircumference}
            strokeDashoffset={strokeDashoffset}
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />
        </g>
        {/* Non-rotating text */}
        <text
          x="51%"
          y="52%"
          dominantBaseline="middle"
          textAnchor="middle"
          style={{ fill: textcolor, fontSize: "0.8rem", fontWeight: "bold" }}
        >
          {`${score}%`}
        </text>
      </svg>
    </div>
  );
};

const ResumeCard = ({
  name,
  date,
  dateIcon,
  type,
  mail,
  location,
  locationIcon,
  percentage,
  resume,
  id,
  jobPostId,
  ApplicantId,
  pic,
  jobTitle,
}) => {
  const navigate = useNavigate(); // Correctly use the navigate function

  const [resumeOpen, setResumeOpen] = useState(false);

  // date to dd-mm-yyyy conversion
  if (date) {
    const d = new Date(date);
    date = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
  }
  return (
    <div
      className="bg-[#ffffff] pb-5 pt-2 px-2 text-black rounded-xl  flex flex-col items-center mt-4 cursor-pointer lg:w-[375px] md:w-[375px] w-full  "
      style={{ boxShadow: "0px 0px 50px 10px rgba(0, 0, 0, 0.04)" }}
      onClick={() => {
        if (type === "jobPost") {
          navigate(`/company/job-applicants/${id}`); // Use navigate correctly
        } else if (type === "applications") {
          navigate(`/company/job-applicants/${jobPostId}?applicant=${id}`); // Use navigate correctly
          console.log(
            `/company/job-applicants/${jobPostId}?applicant=${ApplicantId}`
          );
          console.log(toJS(ApplicantId?._id));
        } else if (type === "resumeSorting") {
          //  console.log("Navigating to resumeSorting with id:", id);
          // navigate(`/company/resumescore/${id}`); // Use navigate correctly
        } else if (type === "interview") {
          //  navigate(`/interview/${id}`); // Use navigate correctly
        } else if (type === "mockTest") {
          //  navigate(`/mockTest/${id}`); // Use navigate correctly
        } else {
          console.log("Unknown type:", type);
        }
      }}
    >
      <div className="flex items-center gap-2 mx-2 font-medium">
        <img
          src={pic || man}
          alt="Profile"
          className="w-14 h-14 rounded-full object-contain"
          // onClick={(e) => e.stopPropagation()} // Prevent event propagation on image click
        />
        <div>
          <div className="flex items-center text-sm">
            <div
              className="flex flex-col gap-2 md:w-fit lg:w-fit w-[64%] text-sm"
              // onClick={(e) => e.stopPropagation()} // Prevent event propagation on content click
            >
              <h1 className="flex text-sm gap-2">
                <p className="text-gray-500">Name:</p>{" "}
                <p className="truncate w-36">{name}</p>
              </h1>
              <div className="flex w-36  gap-2">
                {type === "jobPost" ? (
                  <>
                    <p className="flex items-center truncate text-xs w-20">
                      <AiOutlineCalendar /> {date}
                    </p>
                    <p className="flex items-center truncate text-xs w-20">
                      <CiLocationOn /> {location ?? "-"}
                    </p>
                  </>
                ) : (
                  <p
                    className="flex items-center gap-1 w-36"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <HiOutlineMail className="flex-shrink-0" />
                    {mail !== " - " || type !== "applications" ? (
                      <a className="truncate text-gray-500">{mail}</a>
                    ) : (
                      " - "
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className="mr-2">
              <ScoreCircle score={percentage} className="" />
            </div>
          </div>
          <div className="flex items-center w-full -mt-2 pr-5 justify-between">
            {/* <p> .</p> */}
            <p
              onClick={(e) => {
                e.stopPropagation();
                if (type === "resumeSorting") {
                  setResumeOpen(true);
                } else {
                  navigate(
                    `/company/job-applicants/${jobPostId}?applicant=${id}`
                  );
                }
              }}
              className="flex items-center gap-1 text-sm text-primary"
            >
              <GoFileDiff />{" "}
              <p className="hover:underline">
                {type === "resumeSorting" ? "View Resume" : jobTitle}
              </p>
            </p>
            <p className="text-black text-xs whitespace-nowraps lg:mr-0 md:mr-0 mr-0.5">
              Overall Score
            </p>
          </div>
        </div>
      </div>
      {resumeOpen && (
        <PdfViewer pdfUrl={resume} onClose={() => setResumeOpen(false)} />
      )}
      {/* <div className="flex flex-col items-center justify-center right-0 ml-auto"> */}
      {/* </div> */}{" "}
    </div>
  );
};

export default ResumeCard;
